import { kebabCase } from 'lodash';

import { createStorageScope } from './createStorageScope';

export function createStorageKey(storageKey: string) {
  return `${createStorageScope()}-${kebabCase(storageKey)}`;
}
